<template>
  <au-layout class="excel-convert" title="Excel数据互转">
    <template slot="main">
      <div class="operate-area">
        <el-input v-model="file_name" clearable placeholder="文件名" style="width: 200px;"></el-input>
        <div>
          <el-select v-model="show_columns" multiple collapse-tags style="margin-right: 10px">
            <el-option v-for="key in prop_options" :key="key" :label="key" :value="key">
            </el-option>
          </el-select>
          <au-button :rgb="[99, 187, 208]" @click="handleExportExcel">导出Excel</au-button>
          <au-button :rgb="[248, 179, 127]" @click="handleExportTxt">导出TXT</au-button>
          <au-button type="danger" @click="handleClean">清空</au-button>
        </div>
      </div>
      <au-table ref="table" :data="table_data" :columns="columns" :fixed-height="120"></au-table>
    </template>
    <template slot="aside">
      <el-form ref="form" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="input_data" type="textarea" :rows="8" placeholder="请输入JSON或者数组"></el-input>
          <div style="text-align: right;margin-top: 10px;">
            <au-button type="primary" @click="handleConvert">开始转换</au-button>
          </div>
        </el-form-item>
        <el-divider>或</el-divider>
        <el-form-item>
          <au-upload :multiple="false" @change="onChange"></au-upload>
        </el-form-item>
        <el-form-item>
          <el-descriptions title="文件信息" :label-style="{ width: '80px' }" :column="1" size="mini" border>
            <el-descriptions-item label="名称">
              {{ file_info.name }}
            </el-descriptions-item>
            <el-descriptions-item label="大小">
              {{ file_info.size }}
            </el-descriptions-item>
            <el-descriptions-item label="类型">
              {{ file_info.type }}
            </el-descriptions-item>
            <el-descriptions-item label="修改时间">
              {{ file_info.lastModified }}
            </el-descriptions-item>
          </el-descriptions>
        </el-form-item>
      </el-form>
    </template>
  </au-layout>
</template>

<script>
/**
 * @description Excel转换
 * @created 2024/04/20 14:13:06
 */
// 常量
import { FORMAT_DATETIME } from "@/constants/format"
// npm
import { read, utils, writeFile } from "xlsx"
// 工具
import { isJson, checkType } from "@/utils/validate"
export default {
  name: "ExcelConvert",
  data() {
    return {
      file_name: "",
      prop_options: [],
      table_data: [],
      input_data: "",
      file_info: {},
      show_columns: []
    }
  },
  computed: {
    columns() {
      return this.show_columns.map(key => {
        return {
          prop: key,
          label: key
        }
      })
    }
  },
  watch: {
    prop_options(newValue) {
      this.show_columns = newValue.map(key => key)
    }
  },
  methods: {
    onChange({ raw }) {
      const nameList = raw.name.split(".")
      this.file_name = nameList.slice(0, nameList.length - 1).join(".")
      this.file_info = {
        name: this.file_name,
        size: `${(raw.size / 1024 / 1024).myFixed()}M`,
        type: nameList[nameList.length - 1],
        lastModified: this.$dayjs(raw.lastModified).format(FORMAT_DATETIME)
      }
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        const data = e.target.result
        const workbook = read(data, { type: "array" })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        // 这里得到的是一个二维数组
        const dyadicArray = utils.sheet_to_json(worksheet, { header: 1 })
        this.$message.success("导入成功！")
        console.time("处理耗时")
        const tableData = []
        dyadicArray.forEach((list, index) => {
          if (index === 0) {
            // 列头
            this.prop_options = list
            return
          }
          const isAllEmpty = list.every(item => !item)
          if (isAllEmpty) return
          const obj = {}
          this.prop_options.forEach((key, propIndex) => {
            obj[key] = list[propIndex]
          })
          tableData.push(obj)
        })
        // 表格数据
        this.table_data = tableData
        this.input_data = JSON.stringify(tableData)
        // 每次数据更新都有可能导致列重排异常，调用以下函数即可解决，列拖动导致异常同理
        this.$refs.table.doLayout()
        console.timeEnd("处理耗时")
      }
      fileReader.readAsArrayBuffer(raw)
    },
    handleClean() {
      if (this.table_data.length === 0) {
        this.$message.warning("表格数据为空，无需清空！")
        return
      }
      this.$confirm("该操作会清空整个表格数据，且不可恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.file_info = {}
        this.file_name = ""
        this.prop_options = []
        this.show_columns = []
        this.table_data = []
        // 每次数据更新都有可能导致列重排异常，调用以下函数即可解决，列拖动导致异常同理
        this.$refs.table.doLayout()
      })
    },
    handleExportExcel() {
      // 通过 xlsx 导出 table_data
      if (this.table_data.length === 0) {
        this.$message.warning("表格数据为空，无需导出！")
        return
      }
      const worksheet = utils.json_to_sheet(this.table_data)
      const workbook = utils.book_new()
      utils.book_append_sheet(workbook, worksheet, "Sheet1")
      const currentDate = this.$dayjs().format(FORMAT_DATETIME)
      writeFile(workbook, `${this.file_name || "未命名文件"} ${currentDate}.xlsx`)
    },
    handleExportTxt() {
      if (this.table_data.length === 0) {
        this.$message.warning("表格数据为空，无需导出！")
        return
      }
      const headerTxt = Object.keys(this.table_data[0]).join(",")
      const txtList = this.table_data.map((item) => {
        return Object.values(item).join(",")
      })
      txtList.unshift(headerTxt)
      const txt = txtList.join("\r\n")
      // 开始导出
      const blob = new Blob([txt], { type: "text/plain;charset=utf-8" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      const currentDate = this.$dayjs().format(FORMAT_DATETIME)
      link.download = `${this.file_name || "未命名文件"} ${currentDate}.txt`
      link.click()
      URL.revokeObjectURL(url)
    },
    handleConvert() {
      if (!this.input_data) {
        this.$message.warning("请输入要转换的JSON或者数组！")
        return
      }
      if (!isJson(this.input_data)) {
        this.$message.error("输入内容格式不正确！")
        return
      }
      const result = JSON.parse(this.input_data)
      if (checkType(result) === "Array") {
        // 数组
        this.table_data = result
        this.prop_options = Object.keys(result[0])
      } else {
        // 对象
        this.table_data = [result]
        this.prop_options = Object.keys(result)
      }
      this.file_info = {}
      this.$message.success("转换成功！")
    }
  }
}
</script>

<style lang="scss" scoped>
.excel-convert {
  .operate-area {
    margin-bottom: 10px;
    @include flex(space-between);
  }
}
</style>
